import {SchoolsTable} from '../Schools';

export const AdminPage = () => {
  return (
    <div>
      <SchoolsTable />
    </div>
  );
};
